import { Component, OnInit } from '@angular/core';
import {logs} from '../../language/logs'
import { ActivatedRoute, Router } from '@angular/router';
import { MyserviceService } from '../../provider/myservice.service';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { thLocale } from 'ngx-bootstrap/locale';
defineLocale('enGb', enGbLocale);
defineLocale('th', thLocale);
@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss']
})
export class LogsComponent implements OnInit {
  lang=localStorage.getItem('lang')=="EN"?"EN":"TH";
  language:any;
  start_date=moment().format("YYYY-MM-DD");
  end_date=moment().format("YYYY-MM-DD");
  submitted=false;
  isLoading=false;
  body:any={};
  users:any=[];
  actions:any=[];
  modalRef:BsModalRef;
  username='';
  action='';
  log_action = { log_action_en: "", log_action_th: ""};
  constructor(
    private route: ActivatedRoute, 
    private router: Router,
    private service:MyserviceService,
    public dialog: MatDialog,
    private localeService : BsLocaleService,
    private modalService: BsModalService) 
    { 
      this.language=logs[this.lang]
    }
  
    

  search_logs:any=[];
  ngOnInit() {
    this.service.postData({},"log/log-option").then((result:any)=>{
      if(!result.code){
        console.log(result)
        var {users,actions}=result.option;
        this.users=users;
        this.actions = actions;
        console.log(users,actions)
        console.log(actions)
      }else{
        Swal.fire(result.message,'','error')
      }
    })
    
    this.route.queryParams.subscribe(params => {
      this.lang= params['lang'];
      if(this.lang!='EN'&&this.lang!='TH'){
        this.lang=localStorage.getItem('lang')=='EN'?'EN':'TH';
        this.language=logs[this.lang];
        this.localeService.use(this.lang.toLowerCase());
      }else{
        this.localeService.use(params['lang'].toLowerCase());
        this.language=logs[params['lang']];
        localStorage.setItem('lang',params['lang']);
      }
   });
  }
  search(){

   if(moment(this.start_date).isAfter(this.end_date)){

    Swal.fire(this.language['invalid_date'],'','error');
   }else{
    this.submitted=true;
    this.isLoading=true;
    console.log(this.action)
    this.service.postData({start_date:this.start_date,end_date:this.end_date,username:this.username,action:this.action},"log/get").then((result:any)=>{
      if(result.code){
        Swal.fire(result.message,'','error')
        this.submitted=false;
      }else{
        this.search_logs=result.data.map((item)=>{
          item.log_date_show=moment(item.log_date).format("DD/MM/YYYY HH:mm:ss");
          return item;
        });
        // alert(this.isLoading)
        this.isLoading=false;
      }
    })
   }

  }
  openModal(template,item) {
    this.body=JSON.parse(item);
    this.modalRef = this.modalService.show(template, {keyboard:true});

    this.modalRef.setClass('modal-lg');

  }

}
